<app-inner-box>
  <app-subpage-header title="Artikel"></app-subpage-header>
<!--  <app-add-edit-modal-->
<!--    (refresh)="listComponent.onRefreshList()"-->
<!--    (articleCreated)="listComponent.openModal($event, 300)"-->
<!--  ></app-add-edit-modal>-->
  <br>
  <app-list #listComponent [articleId]="articleId"></app-list>
</app-inner-box>

